import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'stockholm-close-svg-icon',
    templateUrl: 'stockholm-close-svg-icon.component.html',
    standalone: false
})

export class StockholmCloseSvgIconComponent implements OnInit {
  constructor() { }

  ngOnInit() { }
}
